import { render, staticRenderFns } from "./CalciatoreGallery.vue?vue&type=template&id=a44546fa&scoped=true&"
import script from "./CalciatoreGallery.vue?vue&type=script&lang=js&"
export * from "./CalciatoreGallery.vue?vue&type=script&lang=js&"
import style0 from "./CalciatoreGallery.vue?vue&type=style&index=0&id=a44546fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44546fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a44546fa')) {
      api.createRecord('a44546fa', component.options)
    } else {
      api.reload('a44546fa', component.options)
    }
    module.hot.accept("./CalciatoreGallery.vue?vue&type=template&id=a44546fa&scoped=true&", function () {
      api.rerender('a44546fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/CalciatoreGallery.vue"
export default component.exports